import Prism from "prismjs";
import "prismjs/components/prism-c";
import "prismjs/components/prism-rust";
import "prismjs/components/prism-toml";
import "prismjs/plugins/keep-markup/prism-keep-markup";

if (typeof window !== "undefined") {
  window.Prism = window.Prism || {};
  window.Prism.manual = true;
}

export default Prism;
